module.exports = __webpack_public_path__ + "images/construction.4d1de1ff9d81d4a7aca4b23353d5710e.png";